import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import pathfinder from '@fiverr-private/pathfinder';

import './style.scss';
import { HEADER_NAV_SOURCE } from '../../constants';

const UserBalanceTag = ({ balance, isPro, isSeller, onSellerNav }) => {
    if (!balance) {
        return null;
    }

    const balanceClassname = classnames('user-balance', {
        'grey-1200-balance': isPro || onSellerNav,
    });

    const buyerBalanceLinkPath = pathfinder(
        'billing_page_tab',
        { tab: 'balances' },
        { query: { source: HEADER_NAV_SOURCE } }
    );
    const sellerBalanceLinkPath = pathfinder('earnings_page', null, { query: { source: HEADER_NAV_SOURCE } });
    const href = isSeller ? sellerBalanceLinkPath : buyerBalanceLinkPath;
    return (
        <a className={balanceClassname} href={href}>
            {balance}
        </a>
    );
};

UserBalanceTag.propTypes = {
    balance: PropTypes.string,
    isPro: PropTypes.bool,
    isSeller: PropTypes.bool,
    onSellerNav: PropTypes.bool,
};

UserBalanceTag.defaultProps = {
    isPro: false,
};

export default UserBalanceTag;
